import React from 'react';
import mobile from '../../../../assets/conference/mobile.mp4';

const VideoSlide = () => {
    return (
        <div className="absolute inset-0 bg-black animate-zoom-in-video overflow-hidden flex justify-center">
            <video
                src={mobile}
                autoPlay
                playsInline
                loop
                className="h-full object-cover"
            />
        </div>
    );
};

export default VideoSlide;
